// extracted by mini-css-extract-plugin
module.exports = {"uk-open":"cta-card_uk-open__8LhVq","grecaptcha-badge":"cta-card_grecaptcha-badge__XkCUi","root":"cta-card_root__2bjXB","bg":"cta-card_bg__d4TL3","tl":"cta-card_tl__nSrEg","tr":"cta-card_tr__vsvDI","br":"cta-card_br__YTvGh","bl":"cta-card_bl__1JrW0","content":"cta-card_content__2Be84","link":"cta-card_link__TdEEE"};
    if(module.hot) {
      // 1750344780127
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  